export const ROUTE_PATH = {
  // Auth
  ROUTE_LOGIN: "/login" as const,
  ROUTE_LOGOUT: "/logout" as const,

  // Dashboard
  ROUTE_DASHBOARD: "/dashboard" as const,

  //unauthorized
  ROUTE_UNAUTHORIZED: "/unauthorized" as const,
  
  // Account Status
  ROUTE_ACCOUNT_INACTIVE: "/account-inactive" as const,

  // Edit Layout
  ROUTE_EDIT_LAYOUT: "/edit-layout" as const,
} as const;

export type AppRoutePath = (typeof ROUTE_PATH)[keyof typeof ROUTE_PATH];
